const ErrorTitles = {
  no_required_values: 'Valores requeridos incompletos',
  no_format_values: 'Formato incorrecto.',
  column_not_found: 'Columna "id" no encontrada.',
  client_not_found: 'Cliente no encontrado.',
  domain_not_found: 'Dominio no encontrado.',
  user_not_found: 'Usuario no encontrado.',
  role_not_found: 'Rol no encontrado.',
  group_not_found: 'Grupo no encontrado',
  no_file_readed: 'El archivo no se pudo leer'
}

const GeneralErrorAdvices = {
  valid_import_file: 'Revisa que el formato importado es el correcto.',
  valid_required_column_values: 'Revisa que todas las columnas requeridas del formato cuenten con un valor.',
  valid_entity_id: 'Revisa que existe la entidad con ese identificador.'
}

const ImportationErrorAdvices = {
  no_file_readed: [
    'Asegurate de que el archivo no este dañado.',
    'Asegurate de que el archivo es de formato xlsx.'
  ],
  entity_not_found: [
    GeneralErrorAdvices.valid_import_file,
    GeneralErrorAdvices.valid_entity_id,
    'Asegurate de contar con los permisos suficientes de lectura para la entidad.'
  ],
  no_required_client_values: [
    GeneralErrorAdvices.valid_import_file,
    GeneralErrorAdvices.valid_required_column_values,
    `Recuerda que los valores requeridos de un cliente son:
    Código de cliente (client_code), Nombre (name), RFC (rfc), Persona Jurídica (juridical_person),
    Corre (email), Teléfono (phone), Nombre de Cntacto (contact_name), Calle (street_address),
    Número (ext_num_address), Colonia (district), Delegación/Municipio (delegation_municipality),
    Estado (state), Código postal (zip_code), País (country)`
  ],
  client_not_found: [
    'Verifica que todas las celdas de la columna "client" tienen un valor.',
    'Verifica la existencia del cliente con determinado código.',
    'Verifica que el código de cliente este bien escrito.'
  ],
  domain_not_found_workspace: [
    'Verifica que todas las celdas de la columna "DomainId" tienen un valor.',
    'Verifica que el registro con ese identificador existe.',
    'Verifica que el identificador este bien escrito.'
  ],
  no_required_workspace_values: [
    GeneralErrorAdvices.valid_import_file,
    GeneralErrorAdvices.valid_required_column_values,
    `Recuerda que los valores requeridos para un workspace son:
      Dominio (DomainId), Cliente (ClientCode; código de cliente), Es propietario (Owner; 0, 1, true o false),
      Factura Consolidada (ConsolidatedInvoice; 0, 1, true o false), Fecha de Facturación (FacturationDate; 1 - 31),
      Nombre de contacto (ContactName), Teléfono de contacto (ContactPhone), Correo de contacto (ContactEmail).`
  ],
  no_required_domain_values: [
    GeneralErrorAdvices.valid_import_file,
    GeneralErrorAdvices.valid_required_column_values,
    `Recuerda que los valores requeridos para un dominio son:
      Nombre (name), Nivel de seguridad (securityLevel; 0, 4, 8), Revisión mínima de Web BMF (webBMFMinimumRevision),
      Marcado predictivo (usePredictiveDialerOpt; 0, 1, false, true), Límite de licencias (limitLicenses),
      Provedor de mapas (mapProvider; MAPBOX, GOOGLE), Tipo de búsqueda por texto (fullTextSearchType; ELASTIC_SEARCH, SOLR),
      Tasa de tiempo límite (rateLimitTime), Tasa límite de WS (rateLimitWS), Modo de seguimiento (trackingMode; pasivo, intensivo),
      Línea de producto (productLine), Segmento de negocio (máx tres caracteres), 
      Tipo de Dominio (domainType; ecosistema, individual), Código de facturación (billingCode; 10 caracteres).`
  ],
  no_required_user_values: [
    GeneralErrorAdvices.valid_import_file,
    GeneralErrorAdvices.valid_required_column_values,
    `Recordar que los valores requeridos para un usuario son:
    Nombre (name), Correo (email), Facturable (billable), Permisos extendidos (extendedPermissions),
    Cliente (clientId), Dominio (domainId), Rol (roleId)
   `
  ],
  no_required_group_values: [
    GeneralErrorAdvices.valid_import_file,
    GeneralErrorAdvices.valid_required_column_values,
    `Recuerda que los valores mínimos requeridos para un grupo son:
    Nombre, DominioId.
    También puedes agregar valores de SubgruposIds; identificadores de los subgrupos,
    UsuariosIds; identificadores de los usuarios que comparten el grupo,
    ProyectosIds; identificadores de los proyectos relacionados.
   `
  ]
}

enum LoginErrorCodes {
  CREDENTIAL_ERROR = 2600
}

const LoginErrorDescriptions = {
  incorrect_values: 'Incorrect username or password',
  active_license: 'User has an active license on another device',
  device_in_use: 'Device is active with another license',
  device_ressetle: 'Device is in resettle status',
  status_invalid: 'Invalid user status',
  over_attemps: 'the number of attempts to match the password has been exceeded'
}
const LoginErrorDescriptionsTranslate = {
  incorrect_values: 'Accesos incorrectos. Por favor, revise su dominio, usuario y contraseña. Si persiste el problema comuníquese a soporte para ayudarlo +525552800045, opción 1',
  active_license: 'Tu usuario ya cuenta con una licencia activa en otro navegador.',
  device_in_use: 'Este dispositivo/navegador se encuentra activo con una licencia. Es necesario liberar para poder ingresar.',
  device_ressetle: 'Este dispositivo/navegador se encuentra en estado RESSETLE, no es posible ingresar.',
  status_invalid: 'Su licencia ha sido suspendida o cancelada por temas administrativos para cualquier duda comuníquese a finanzas al + 525552800045, opción 4',
  over_attemps: 'Haz sobre pasado la cantidad de intentos para iniciar sesión. Por favor, espera 5 min e intenta de nuevo.',
  invalid_role: 'Licencia para la aplicación móvil. Su licencia es para uso de la aplicación móvil no para la plataforma web. Por favor llámenos a soporte para ayudarlo +525552800045, opción 1',
  domain_temporarily_closed: 'El dominio se encuentra temporalmente cerrado.',
  undefined_error: 'Problema no reconocido.'
}

const RecoveryPasswordErrors = {
  incorrect_values: 'Incorrect domain or user',
  incorrect_password: 'password has a invalid format',
  incorrect_pin: 'Incorrect pin',
  invalid_user_status: 'Invalid user status',
  missing_password: 'Missing new_password parameter value',
  over_attemps: 'the number of attempts to match the password has been exceeded'
}
const RecoveryPasswordErrorTranslate = {
  incorrect_values: 'El usuario o el dominio son incorrectos.',
  incorrect_password: 'La constraseña no cumple con las características mínimas de seguridad.',
  incorrect_pin: 'Has ingresado un PIN no válido. Puede que este haya caducado o ya ha sido utilizado.',
  invalid_user_status: 'El usuario se encuentra suspendido o inactivo. No es posible actualizar la contraseña.',
  missing_password: 'Es necesario ingresar una nueva contraseña.',
  over_attemps: 'Se ha superado el número de intentos para el cambio de contraseña. Por favor, espera 5 min e intenta de nuevo.'
}

export {
  ErrorTitles,
  ImportationErrorAdvices,
  LoginErrorCodes,
  LoginErrorDescriptions,
  LoginErrorDescriptionsTranslate,
  RecoveryPasswordErrors,
  RecoveryPasswordErrorTranslate
}
